import styled, { css, keyframes } from 'styled-components';
import { customMedia, cssDropdown, cssDropdownItem } from 'styles/utils';

import { Avatar } from 'components';

import Logo from 'components/Logo';
import Button from 'components/Button';

export const MOBILE_HEIGHT = 48;

const showStickyHeader = keyframes`
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
`;

export const HeaderStyled = styled.header`
  background-color: ${props =>
    props.isDark ? props.theme.color.wfBlack : props.theme.color.wfWhite};
  position: ${props => (props.isSticky ? 'fixed' : 'relative')};
  right: 0;
  left: 0;
  top: 0;
  z-index: 1010;
  ${props =>
    props.isSticky &&
    css`
      box-shadow: rgba(0, 0, 0, 0.1) 0 4px 11px;
      animation: ${showStickyHeader} 0.5s ease-out;
    `};

  ${customMedia.greaterThan('large')`
    position: ${props => props.isSticky && 'sticky'};
  `}

  ${customMedia.lessThan('large')`
    border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  `}
`;

export const HeaderContent = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100vw;
  min-height: ${MOBILE_HEIGHT}px;
  margin: 0 auto;

  ${customMedia.greaterThan('large')`
    width: auto;
    max-width: ${props => !props.isFullWidth && props.theme.layout.maxWidth};
    height: 95px;
    padding: ${props =>
      `${props.theme.spacing.default} ${props.theme.layout.paddingInline}`};
  `}
`;

export const LogoStyled = styled(Logo)`
  width: 34px;

  ${customMedia.greaterThan('large')`
    width: 55px;
  `}
`;

export const ButtonBlock = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  background-color: transparent;

  &:hover {
    opacity: 0.75;
  }

  svg {
    path {
      fill: ${props =>
        props.negativeVersion
          ? props.theme.color.wfWhite
          : props.theme.color.wfBlack};
    }
  }

  ${customMedia.lessThan('large')`
    min-width: 60px;
    min-height: ${MOBILE_HEIGHT}px;
    border-${props =>
      props.borderRight ? 'right' : 'left'}: 1px solid ${props =>
    props.theme.color.wfGrey200};
  `}
`;

export const HamburgerButtonBlock = styled(ButtonBlock)`
  ${customMedia.greaterThan('large')`
    display: none;
  `}
`;

export const UserNav = styled.nav`
  display: flex;
  align-items: center;
  order: 3;
  > button + button,
  > div {
    margin-left: ${props => props.theme.spacing.default};
  }

  ${customMedia.lessThan('large')`
    display: none;
  `}
`;

export const MobileUserNavWrapper = styled(UserNav)`
  justify-content: flex-end;
  order: initial;
  width: 100%;
  margin-right: ${props => props.theme.spacing.default};

  ${customMedia.greaterThan('large')`
    display: none;
  `}
  ${customMedia.lessThan('large')`
    display: flex;
  `}
`;

export const UserNavItem = styled.div`
  position: relative;
`;

export const UserNavButton = styled(Button)`
  ${customMedia.lessThan('large')`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    padding: 0;
  `}
`;

export const Dropdown = styled.ul`
  font-size: ${props => props.theme.font.size.default};

  ${customMedia.lessThan('large')`
    border-top: 1px solid ${props => props.theme.color.wfGrey200};
    padding-top: ${props => props.theme.spacing.small};
  `}
  ${customMedia.greaterThan('large')`
    top: 56px;
    right: ${props => props.userMenu && 0};
    display: ${props => (props.isVisible ? 'block' : 'none')};
    ${cssDropdown}
  `}
`;

export const DropdownItem = styled.li`
  cursor: pointer;
  padding: ${props => `${props.theme.spacing.small} 0`};
  color: ${props =>
    props.active ? props.theme.color.wfBlue : props.theme.color.wfBlack};

  a {
    color: inherit;
    display: block;

    &:hover {
      text-decoration: none;
    }
  }

  ${customMedia.greaterThan('large')`
    ${cssDropdownItem}
    text-align: left;
  `}
`;

export const DropdownTitle = styled.li`
  padding: ${props =>
    `${props.theme.spacing.small} ${props.theme.spacing.default}`};
  color: ${props => props.theme.color.greyDarker};
  font-weight: ${props => props.theme.font.weight.xbold};
  font-size: ${props => props.theme.font.size.small};
`;

export const DropdownSeparator = styled.hr`
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid ${props => props.theme.color.wfGrey200};
`;

export const Actions = styled.ul`
  display: none;

  ${customMedia.greaterThan('large')`
    display: block;
  `}
`;

export const ActionItem = styled.li`
  display: inline-block;
  & + & {
    margin-left: ${props => props.theme.spacing.medium};
  }
`;

export const ProfileAvatar = styled(Avatar)`
  width: 44px;
  height: 44px;
  cursor: pointer;
  border: 1px solid
    ${props =>
      props.negativeVersion
        ? props.theme.color.wfWhite
        : props.theme.color.wfGrey700};

  ${customMedia.lessThan('large')`
    width: 32px;
    height: 32px;
  `}
`;

// FIXME: Refactor from here

export const LogoWhiteLabel = styled.img`
  width: auto;
  height: 40px;
  &:hover {
    opacity: 0.9;
  }
`;

export const WhiteLabelLogoWrapper = styled.div`
  display: inline-block;
`;

export const LogoDivider = styled.div`
  /* TODO: imported also in other files. Review. */
  height: 40px;
  width: 1px;
  background-color: ${props => props.theme.color.wfGrey200};
  display: inline-block;
  margin: 0 ${props => props.theme.spacing.default};
`;
